<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1 bg-img" id="kt_login"  style="background-image: url(./assets/media/bg/trial1.jpg);">
	
	
	<div
	class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile bggif">
	<!--begin::Aside-->
	<div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside">
		<div class="kt-grid__item">
			<a href="/login" class="kt-login__logo">
				<img src="./assets/media/bg/logos.png" alt="">
			</a>
		</div>
	</div>
	
		<!--begin::Aside-->

		<!--begin::Content-->
	<div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper pt-0">
			<router-outlet></router-outlet>
		</div>
		

		

		<!--end::Content-->
	</div>
	</div>
	
